/**
 * Where this page reaches the SFU node the orchestrator assigned.
 *
 * The orchestrator answers with the node's internal address. Moved out of
 * `useSfuJoin` unchanged, so the Screen Share page resolves a node exactly the
 * way the meeting does — the same way video.html does.
 *
 * `page` is read only on the two branches that need it, as the inline version
 * did, so the common cases never touch `location`.
 */
export function resolveSfuNodeUrl(
  nodeUrl: string,
  orchestratorUrl: string,
  page?: { protocol: string; hostname: string },
): string {
  const nodeUrlParsed = new URL(nodeUrl)
  const nodeHost = nodeUrlParsed.hostname
  const isIp = /^\d+\.\d+\.\d+\.\d+$/.test(nodeHost)
  // Only loopback / RFC-1918 private / link-local addresses count as "local".
  // A public/raw IP must NOT downgrade to http (it would be a blocked insecure
  // request from an https page and an unintended prod behavior change).
  const isLocalIp =
    isIp &&
    /^(127\.|10\.|192\.168\.|169\.254\.|172\.(1[6-9]|2\d|3[01])\.)/.test(nodeHost)
  const isLocal = nodeHost === 'localhost' || isLocalIp
  if (isLocal) {
    // Local dev: talk to the assigned SFU node directly over http.
    // http://localhost|127.0.0.1 is an allowed secure context even from an https page.
    return `http://${nodeHost}:${nodeUrlParsed.port}`
  }
  if (nodeHost.includes('.') && !isIp) return `https://${nodeHost}`
  const loc = page ?? location
  if (loc.protocol === 'https:') return orchestratorUrl
  return `http://${loc.hostname}:${nodeUrlParsed.port}`
}
